<template>
	<div class="page home-page">
		<div class="home-header">
			<div class="header-content">
				<div v-if="!hasToken" class="header-action" @click="toLogin('/Register')">
					{{$t("auth.register")}}
				</div>
				<div v-else class="header-action"></div>
				<div class="header-logo">
					<span class="logo-text">One-night stand</span>
				</div>
				<div class="header-action" v-if="!hasToken" @click="toLogin('/Login')">
					<van-icon name="chat-o" color="#fff" size="20" />
					{{$t("auth.login")}}
				</div>
				<div v-else class="header-action" @click="toLogin('/ServiceOnline')">
					<van-icon name="chat-o" color="#fff" size="20" />
				</div>
			</div>
		</div>

		<div class="banner-wrap">
			<swiper class="banner-swiper" :options="bannerSwiperOption">
				<swiper-slide v-for="(v, key) in banners" :key="key">
					<van-image class="banner-img" :src="`${v.url}`" width="100%" height="160px">
						<template v-slot:loading>
							<van-loading type="circular" />
						</template>
					</van-image>
				</swiper-slide>
			</swiper>
		</div>

		<div class="notice-wrap">
			<van-notice-bar class="notice-bar" color="var(--primary)" background="rgba(255,255,255,.8)" scrollable
				:text="this.notice">
				<template #left-icon>
					<span class="notice-icon">●</span>
				</template>
			</van-notice-bar>
		</div>

		<div class="section">
			<div class="section-header-mini">
				<span class="section-title-mini">{{$t("index.Highend_area")}}{{$t("index.extreme")}}</span>
			</div>
			<div class="scroll-x">
				<div class="scroll-item" v-for="(group, index) in groupedData" :key="index">
					<div v-for="item in group" :key="item.id">
						<div @click="toDetail(item.id)" class="avatar-card">
							<img :src="item.img_url" class="avatar-img" />
							<div class="avatar-badge">{{$t("index.airborne")}}</div>
							<div class="avatar-name">{{ item.xuanfei_name }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="section">
			<div class="section-header-mini">
				<span class="section-title-mini">{{$t("index.recommend")}}</span>
			</div>
			<div class="recommend-list">
				<div class="recommend-item" v-for="item in datalist" :key="item.id" @click="toDetail(item.id)">
					<div class="recommend-img-box">
						<div class="van-image"
							style="width: 120px; height: 120px; overflow: hidden; border-radius: 12px;">
							<img :src="item.img_url" class="van-image__img" style="object-fit: cover;" />
						</div>
						<span class="corner-tag"><i>{{$t("concubine.high_end")}}</i></span>
					</div>
					<div class="recommend-info">
						<div class="recommend-tags">
							<div class="pill-tag">
								<img src="/img/vip.png" style="width: 13px; height: 13px;" />
								<span>{{$t("index.authentication")}}</span>
							</div>
							<div class="pill-tag">
								<img src="/img/vip.png" style="width: 13px; height: 13px;" />
								<span>{{$t("index.video_authentication")}}</span>
							</div>
							<div class="pill-tag name-tag">{{ item.xuanfei_name }}</div>
						</div>
						<div class="tags-row">
							<van-tag style="line-height: 3.133vw;" v-for="(tag, index) in item.flagArray" :key="index"
								:type="tagTypes[index % 4]">
								{{ tag }}
							</van-tag>
						</div>
						<div class="rate-row">
							<span class="rate-label">{{$t("index.toll")}}：</span>
							<van-rate v-model="item.number" color="#ffd21e" size="16px" />
						</div>
						<div class="meta-row">
							{{$t("index.height")}}: {{item.hight}}cm {{$t("index.bust")}}：{{ item.bust }}
							{{$t("index.address")}}：{{$t("index.National")}}：{{$t("index.yes")}}
						</div>
						<div class="action-btn">{{$t("index.about")}}</div>
					</div>
				</div>
			</div>
		</div>

		<div style="padding-bottom: 55px;"></div>

		<div id="overlay" class="overlay" :class="{ active: isActive }">
			<div class="overlay-content">
				<div class="overlay-header">
					<div class="banner-text">{{$t("index.Please_select", "Please select your needs")}}</div>
					<p class="banner-subtext">Choose your preference to continue</p>
				</div>

				<div class="selection-row">
					<div class="selection-card" @click="selectOption(1)">
						<div class="avatar-ring">
							<img src="../images/user/woman.webp" alt="" />
						</div>
						<h3>{{$t("index.Asian_girl", "Asian girl")}}</h3>
						<div class="check-icon"><van-icon name="success" /></div>
					</div>

					<div class="selection-card" @click="selectOption(2)">
						<div class="avatar-ring">
							<img src="../images/user/man.webp" alt="" />
						</div>
						<h3>{{$t("index.European_girl", "European girl")}}</h3>
						<div class="check-icon"><van-icon name="success" /></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isActive: false,
				notice: this.$t("index.loading"),
				hasToken: false,
				basicData: [],
				datalist: [],
				groupedData: [],
				banners: [{}],
				bannerSwiperOption: {
					effect: 'coverflow',
					grabCursor: true,
					centeredSlides: true,
					slidesPerView: 'auto',
					speed: 800,
					autoplay: true,
					coverflowEffect: {
						rotate: 50,
						stretch: 10,
						depth: 100,
						modifier: 1,
						slideShadows: true
					}
				},
				tagTypes: ['primary', 'success', 'danger', 'warning'],
			};
		},
		methods: {
			getBasicConfig() {
				const selid = this.getCookie('selid') || 1;
				this.$http({
					method: "get",
					url: "sys_config",
					data: {
						id: selid
					},
				}).then((res) => {
					this.basicData = res.data;
					this.getNotice(this.basicData);
					this.getBanner(this.basicData);
				});
			},
			getBanner(data) {
				this.banners = data.banners;
			},
			toLogin(str) {
				this.$router.push({
					path: str
				});
			},
			getNotice(data) {
				this.notice = data.notice;
			},
			toDetail(id) {
				this.$router.push({
					path: "/detail",
					query: {
						id: id
					}
				});
			},
			checkToken() {
				const token = localStorage.getItem("token");
				this.hasToken = !!token;
			},
			getxuanfeilist() {
				const selid = this.getCookie('selid');
				if (selid) {
					this.$http({
						method: "get",
						url: "xuanfeilist",
						data: {
							id: selid,
							page: 1
						},
					}).then((res) => {
						const lanng = localStorage.getItem("lang") || 'zh';
						this.datalist = res.data || [];

						this.datalist.forEach(item => {
							const flagContent = item.flag || "";
							const parts = flagContent.split('|');

							let displayFlag = "";
							if (lanng === 'zh') displayFlag = parts[0];
							else if (lanng === 'en') displayFlag = parts[1];
							else if (lanng === 'ja') displayFlag = parts[2];
							else displayFlag = parts[3];

							item.flag = displayFlag || parts[0] || "";
							item.flagArray = item.flag ? item.flag.split('，') : [];
						});

						const chunkSize = 2;
						this.groupedData = this.datalist.reduce((acc, item, index) => {
							if (index % chunkSize === 0) acc.push([]);
							acc[Math.floor(index / chunkSize)].push(item);
							return acc;
						}, []);
					});
				} else {
					this.isActive = true;
				}
			},
			setCookie(name, value, days) {
				let expires = '';
				if (days) {
					const date = new Date();
					date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
					expires = '; expires=' + date.toUTCString();
				}
				document.cookie = name + '=' + (value || '') + expires + '; path=/';
			},
			getCookie(name) {
				name = name + '=';
				const decodedCookie = decodeURIComponent(document.cookie);
				const cookies = decodedCookie.split(';');
				for (let i = 0; i < cookies.length; i++) {
					let cookie = cookies[i];
					while (cookie.charAt(0) === ' ') {
						cookie = cookie.substring(1);
					}
					if (cookie.indexOf(name) === 0) {
						return cookie.substring(name.length, cookie.length);
					}
				}
				return '';
			},
			selectOption(num) {
				this.setCookie('selid', num, 1);
				this.isActive = false;
				this.getBasicConfig();
				this.getxuanfeilist();
			},
		},
		created() {
			this.checkToken();
			this.getBasicConfig();
			this.getxuanfeilist();
		},
	};
</script>

<style lang="less" scoped>
	.home-page {
		padding-bottom: 130px;
	}

	/* Header */
	.home-header {
		height: 100px;
		background: linear-gradient(135deg, #7c6ff0, #db6ea9);
	}

	.header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 100%;
		padding: 0 24px;
		color: #fff;
		font-size: 24px;
	}

	.header-logo {
		height: 64px;
		display: flex;
		/* 增加 flex 使文字垂直居中 */
		align-items: center;
		justify-content: center;

		.logo-text {
			font-family: 'Arial', sans-serif;
			/* 可以替换为你喜欢的字体 */
			font-size: 20px;
			font-weight: 800;
			color: #ffffff;
			text-transform: uppercase;
			/* 让文字看起来更像 Logo */
			letter-spacing: 1px;
			text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
			white-space: nowrap;
			/* 防止换行 */
		}
	}

	.header-action {
		display: flex;
		align-items: center;
		gap: 6px;
		cursor: pointer;
	}

	/* Banner */
	.banner-wrap {
		padding: 12px 12px 0;
	}

	.banner-swiper {
		border-radius: var(--radius-lg);
		overflow: hidden;
	}

	.banner-img {
		border-radius: var(--radius-lg);
	}

	/* Notice */
	.notice-wrap {
		padding: 10px 12px;
	}

	.notice-bar {
		border-radius: var(--radius-md) !important;
	}

	.notice-icon {
		color: var(--primary);
		font-size: 10px;
		margin-right: 8px;
	}

	/* Section */
	.section {
		padding: 0 12px 12px;
	}

	.section-header-mini {
		padding: 12px 0 8px;
	}

	.section-title-mini {
		font-size: 16px;
		font-weight: 700;
		color: var(--text);
		position: relative;
		padding-left: 12px;

		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 2px;
			bottom: 2px;
			width: 4px;
			border-radius: 999px;
			background: linear-gradient(180deg, var(--primary), var(--accent));
		}
	}

	/* Scroll area */
	.scroll-x {
		display: flex;
		/* 保持 flex 布局 */
		overflow-x: auto;
		/* 允许横向滚动 */
		overflow-y: hidden;
		/* 禁止纵向滚动 */
		gap: 12px;
		padding: 10px 12px;
		-webkit-overflow-scrolling: touch;
		/* 惯性滚动 */
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}
	}

	.scroll-item {
		display: flex;
		/* 只要父级是 flex，子级不需要 inline-flex */
		gap: 10px;
		flex-shrink: 0;
	}

	.avatar-card {
		position: relative;
		width: 100px;
		height: 120px;
		border-radius: var(--radius-md);
		overflow: hidden;
		box-shadow: var(--shadow-soft);
		background: rgba(255, 255, 255, .7);
		cursor: pointer;
		transition: transform .2s ease;

		&:active {
			transform: scale(.96);
		}
	}

	.avatar-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.avatar-badge {
		position: absolute;
		top: 6px;
		right: 6px;
		background: rgba(219, 110, 169, .85);
		color: #fff;
		font-size: 10px;
		padding: 2px 8px;
		border-radius: 999px;
		backdrop-filter: blur(6px);
	}

	.avatar-name {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 6px;
		background: linear-gradient(transparent, rgba(0, 0, 0, .5));
		color: #fff;
		font-size: 12px;
		text-align: center;
	}

	/* Recommend List */
	.recommend-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.recommend-item {
		display: flex;
		gap: 12px;
		padding: 12px;
		background: rgba(255, 255, 255, .74);
		border-radius: var(--radius-lg);
		box-shadow: var(--shadow-soft);
		backdrop-filter: blur(16px);
		-webkit-backdrop-filter: blur(16px);
		border: 1px solid rgba(255, 255, 255, .72);
		cursor: pointer;
		transition: transform .2s ease;

		&:active {
			transform: scale(.99);
		}
	}

	.recommend-img-box {
		position: relative;
		overflow: hidden;
		border-radius: 12px;
		flex-shrink: 0;
	}

	.corner-tag {
		position: absolute;
		z-index: 9;
		background-color: #ebcaaf;
		color: #8d684b;
		transform: rotate(45deg);
		width: 80px;
		height: 80px;
		top: -44px;
		right: -44px;

		i {
			position: absolute;
			bottom: 5px;
			left: 50%;
			transform: translateX(-50%);
			font-weight: 700;
			font-size: 12px;
		}
	}

	.recommend-info {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.recommend-tags {
		display: flex;
		gap: 6px;
		flex-wrap: wrap;
	}

	.pill-tag {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		background: linear-gradient(180deg, #e7caaf, #fff7ed);
		color: #a4826b;
		font-weight: 600;
		font-size: 11px;
		padding: 2px 8px;
		border-radius: 999px;

		&.name-tag {
			width: 70px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.rate-row {
		display: flex;
		align-items: center;
		gap: 4px;
	}

	.rate-label {
		font-size: 14px;
		color: #666;
	}

	.meta-row {
		color: #999;
		font-size: 12px;
	}

	.action-btn {
		background: var(--gradient-primary);
		color: #fff;
		border-radius: var(--radius-sm);
		padding: 10px 0;
		text-align: center;
		font-size: 13px;
		font-weight: 600;
		margin-top: 2px;
	}

	/* =========================================
   放大版深色质感 Overlay Selection
========================================= */
	.overlay {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		/* 更深的背景底色，贴合参考图的高级深灰 */
		background: rgba(30, 30, 36, 0.95);
		backdrop-filter: blur(15px);
		-webkit-backdrop-filter: blur(15px);
		display: none;
		justify-content: center;
		align-items: center;
		z-index: 99999;

		&.active {
			display: flex;
			animation: fadeIn 0.3s ease-out forwards;
		}
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: scale(1.03);
		}

		to {
			opacity: 1;
			transform: scale(1);
		}
	}

	.overlay-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 36px;
		width: 100%;
	}

	.overlay-header {
		text-align: center;
		padding: 0 20px;
	}

	.banner-text {
		font-size: 46px;
		/* 匹配参考图的字号感 */
		color: #ffffff;
		font-weight: bold;
		letter-spacing: 0.5px;
		margin-bottom: 8px;
	}

	.banner-subtext {
		font-size: 30px;
		color: #8c8c9b;
		/* 参考图中略偏灰的副标题颜色 */
		font-weight: 400;
	}

	.selection-row {
		display: flex;
		gap: 16px;
		padding: 0 16px;
		justify-content: center;
		flex-wrap: wrap;
		/* 关键：允许在屏幕不够宽时自动换行，防止内容溢出 */
	}

	/* 放大后的卡片设计 */
	.selection-card {
		width: 150px;
		/* 稍微回调一点，确保在一行能放下两个，或者自动换行 */
		max-width: 45vw;
		position: relative;
		width: 300px;
		/* 宽度放大 */
		background: rgba(255, 255, 255, 0.08);
		/* 稍微提亮一点点卡片底色，与背景拉开层次 */
		border: 1px solid rgba(255, 255, 255, 0.12);
		border-radius: 20px;
		/* 大圆角 */
		padding: 30px 12px 24px;
		/* 增加上下内边距，让卡片看起来更修长厚实 */
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 18px;
		/* 头像与文字的间距放大 */
		cursor: pointer;
		transition: all 0.25s ease;
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);

		/* 点击交互 */
		&:active {
			transform: scale(0.96);
			background: rgba(255, 255, 255, 0.15);
			border-color: rgba(255, 255, 255, 0.3);

			.check-icon {
				opacity: 1;
				transform: scale(1);
			}
		}

		h3 {
			color: #ffffff;
			font-size: 30px;
			/* 选项文字放大 */
			font-weight: 600;
			margin: 0;
			text-align: center;
			line-height: 1.3;
		}
	}

	/* 头像同步放大 */
	.avatar-ring {
		width: 175px;
		/* 从100px放大到115px */
		height: 175px;
		border-radius: 50%;
		padding: 3px;
		background: linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.05));
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.5);
		/* 增加头像的阴影层次 */

		img {
			width: 100%;
			height: 100%;
			border-radius: 50%;
			object-fit: cover;
		}
	}

	/* 隐藏的打钩图标 */
	.check-icon {
		position: absolute;
		top: 14px;
		right: 14px;
		width: 24px;
		height: 24px;
		background: #ffffff;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #333;
		/* 黑底白勾，更显眼 */
		font-size: 14px;
		font-weight: bold;
		opacity: 0;
		transform: scale(0.5);
		transition: all 0.2s ease;
	}
</style>